import store from '@/store/index.js'
import { makeRequest } from '@/libs/RequestModule'

const loadFinance = async function () {
    const { CDCONSUMIDOR } = store.getters.getCurrDependent
    const DTINI = store.getters.getSummaryDate[0].value
    const DTFIM = store.getters.getSummaryDate[1].value

    const fullExtrato = (await makeRequest('extrato', { CDCONSUMIDOR, DTINI, DTFIM }))?.data
    store.dispatch('setFinancialMedia', fullExtrato.expenseAvarage)
    store.dispatch('setFinancialData', fullExtrato.extract)
}

const loadFinanceByPeriod = async function (initialDate, finalDate) {
    const { CDCONSUMIDOR } = store.getters.getCurrDependent
    const DTINI = initialDate
    const DTFIM = finalDate

    const fullExtrato = (await makeRequest('extrato', { CDCONSUMIDOR, DTINI, DTFIM }))?.data
    store.dispatch('setFinancialMedia', fullExtrato.expenseAvarage)
    store.dispatch('setFinancialData', fullExtrato.extract)
}

const getStoreBalance = async function () {
    const { CDCONSUMIDOR } = store.getters.getCurrDependent
    return (await makeRequest('getStoreBalance', { CDCONSUMIDOR }))?.data
}

const getFullBalance = async function () {
    return (await makeRequest('getFullBalance'))?.data
}

export { getStoreBalance, loadFinance, loadFinanceByPeriod, getFullBalance }
